import { isUndefined } from '@atlassiansox/bxp-shared-utils';

export type Headers = {
  readonly [name: string]: string;
};

export function createHeaders(headers: {
  readonly [name: string]: string | number | boolean | undefined;
}): Headers {
  return Object.keys(headers).reduce((result, name) => {
    const value = headers[name];
    if (!isUndefined(value)) {
      return {
        ...result,
        [name]: value.toString()
      };
    } else {
      return result;
    }
  }, {});
}
